// import { useMemo } from "react";
// import { getPercent } from "../../../../utils/functions";
// import classes from "./AiInsights.module.css";
// import ProgressBar from "../../../UI/ProgressBar/ProgressBar";
// import { BorderPoint, LightStar } from "../../../../constants/svg";

// const scores = ["Stress tolerance", "Collaboration", "Judgement", "Teamwork", "Responsibility", "Adaptability", "Clarity", "Creativity", "Communication"]

// const abilitiesKeys = ["pressure", "collaboration", "teamManagement", "teamWork", "sales", "planning", "clientRelationship", "creativity", "communication"]

// const AiInsightsVisual = ({ abilities = {}, aiInsights = {}, type, submittedPsychometricTest }) => {
//   const aiScores = useMemo(() => ([getPercent(aiInsights?.personality?.stressTolerance, 100), getPercent(aiInsights?.personality?.collaboration, 100), getPercent(aiInsights?.sjtScores?.judgment, 100), getPercent(aiInsights?.sjtScores?.teamwork, 100), getPercent(aiInsights?.sjtScores?.responsibility, 100), getPercent(aiInsights?.sjtScores?.adaptability, 100), getPercent(aiInsights?.creativeScore?.clarity, 100), getPercent(aiInsights?.creativeScore?.creativity, 100), getPercent(aiInsights?.creativeScore?.communication, 100)]), [aiInsights])

//   return (
//     <div className={`relative !border-none !shadow-none ${classes.mainContainer}`} type="container">
//       {type === "talent" ? (
//         <div className={`${classes.eduHeader} flex items-center mb-6`}>
//           <h3 className={classes.topTitle}>Score Comparison</h3>
//           <span className={classes.line}></span>
//           <span className={classes.star}>
//             NEW <LightStar />{" "}
//           </span>
//         </div>
//       ) : (
//       <div className="flex flex-col gap-2">
//         <h2 className="text-2xl font-mediun text-[#152238]">
//           Score Comparison
//         </h2>
//         {type === "insights" &&
//         <div className="lg:flex items-center gap-2 justify-end lg:mb-10 hidden">
//           <BorderPoint />
//         </div>
//         }
//       </div>
//       )}
//       <div className={`grid grid-cols-1 md:grid-cols-5 gap-8 ${classes.insightsContainer}`}>
//         <div className="col-span-1 md:col-span-2 grid grid-cols-2 md:grid-cols-1 gap-1">
//           <h6 className="col-span-2 md:col-span-1 h-20 flex items-center justify-center">Talent Score</h6>
//           <div className="md:hidden">
//             {scores.map((score, i) => (<div className="py-3" key={i}>{score}</div>))}
//           </div>
//           <div className="">
//             {abilitiesKeys.map((key, i) => (<ProgressBar key={i} progress={abilities[key]} />))}
//           </div>
//         </div>

//         <div className="col-span-1 md:block hidden mt-20 text-center">
//           {scores.map((score, i) => (<div className="py-4 truncate text-xs" key={i} title={score}>{score}</div>))}
//         </div>

//         <div className="col-span-1 md:col-span-2 grid grid-cols-2 md:grid-cols-1 gap-1">
//           <h6 className="col-span-2 md:col-span-1 h-20 flex items-center justify-center">AI Score</h6>
//           <div className="md:hidden">
//             {scores.map((score, i) => (<div className="py-3" key={i}>{score}</div>))}
//           </div>
//           <div className="">
//             {aiScores.map((score, i) => (<ProgressBar key={i} start="right" progress={submittedPsychometricTest ? (score || 0) : 0} color="#009A49" />))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AiInsightsVisual;

import { IconChartBar } from "@tabler/icons-react";
import styles from "./AiInsights.module.css";

const TalentScoreComparisonCard = ({ traits }) => {
  return (
    <div className={`${styles.card} ${styles.cardScore}`}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconChartBar size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Score Comparison</div>
            <div className={styles.cardSubtitle}>
              Your self-rated score vs. our AI's assessment
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.legend}>
          <span className={styles.legendItem}>
            <span className={`${styles.legendDot} ${styles.legendDotTalent}`} />{" "}
            Talent Score
          </span>
          <span className={styles.legendItem}>
            <span className={`${styles.legendDot} ${styles.legendDotAi}`} /> AI
            Score
          </span>
        </div>
        {traits?.map((t) => (
          <div className={styles.cmpRow} key={t.name}>
            <div className={`${styles.cmpSide} ${styles.cmpSideTalent}`}>
              <span className={`${styles.cmpValue} ${styles.cmpValueTalent}`}>
                {t?.talent}
              </span>
              <div className={styles.cmpTrack}>
                <div
                  className={`${styles.cmpFill} ${styles.cmpFillTalent}`}
                  style={{ width: `${t?.talent}%` }}
                />
              </div>
            </div>
            <div className={styles.cmpName}>{t?.name}</div>
            <div className={styles.cmpSide}>
              <div className={styles.cmpTrack}>
                <div
                  className={`${styles.cmpFill} ${styles.cmpFillAi}`}
                  style={{ width: `${t?.ai}%` }}
                />
              </div>
              <span className={`${styles.cmpValue} ${styles.cmpValueAi}`}>
                {t?.ai}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TalentScoreComparisonCard;
